import EventEmitter from 'src/helpers/EventEmitter'

const Events = {
  UPDATE: 'update',
}

class Gyro {
  constructor() {
    Object.assign(this, EventEmitter, {
      x: 0,
      y: 0,
      z: 0,
      gx: 0,
      gy: 0,
      gz: 0,
      rotation: {
        alpha: 0,
        beta: 0,
        gamma: 0,
      },
      gravity: false,
      landscape: false,
    })

    this.listen()
  }

  _motion = (evt) => {
    const { x, y, z } = evt.acceleration
    const g = evt.accelerationIncludingGravity
    const { alpha, beta, gamma } = evt.rotationRate || null
    const interval = evt.interval
    const timeStamp = evt.timeStamp

    //if (y > 1)
    console.log('evt', evt)



    this.x = this.landscape ? y : x || -1
    this.y = this.landscape ? x : y || -1
    this.z = z || -1
    this.gx = this.landscape ? g.y : g.x || -1
    this.gy = this.landscape ? g.x : g.y || -1
    this.gz = g.z || -1
    this.rotation.alpha = alpha || -1
    this.rotation.beta = beta || -1
    this.rotation.gamma = gamma || -1

    //console.log('ggg', x, y, z, alpha, beta, gamma)

    this.emit(Events.UPDATE, {
      x: this.x,
      y: this.y,
      z: this.z,
      gx: this.gx,
      gy: this.gy,
      gz: this.gz,
      alpha: this.rotation.alpha,
      beta: this.rotation.beta,
      gamma: this.rotation.gamma,
      interval: interval,
      timeStamp: timeStamp
    })
  }

  _orientation = () => {
    this.landscape = window.innerWidth > window.innerHeight
  }

  listen = () => {
    if (this.listening) return
    this.listening = true
    window.addEventListener('devicemotion', this._motion)
    //window.addEventListener('resize', this._orientation)
  }

  unlisten = () => {
    if (!this.listening) return
    this.listening = false
    window.removeEventListener('devicemotion', this._motion)
    //window.removeEventListener('resize', this._orientation)
  }




}

let gyro = new Gyro()
gyro.Events = Events
export default gyro
